<!-- DESKTOP SECTION AMAZON -->
<section style="background: #F9F9F9;" class="py-4" style="min-height: 435px">
  <div id="amazon-desktop-section" class="mx-md-auto position-relative"
       style="max-width: 1220px">
    <picture class="position-absolute d-block d-md-none w-100" style="z-index: 0; bottom: 0">
      <source data-srcset="assets/market/background-mobile.png" type="image/webp">
      <source data-srcset="assets/market/background-mobile.png" type="image/png">
      <img class="lazyload w-100" alt="Amazon para Cuba"
           data-src="assets/market/background-mobile.png">
    </picture>
    <picture class="position-absolute d-none d-md-block" style="z-index: 0; top: 0">
      <source data-srcset="assets/market/background.png" type="image/webp">
      <source data-srcset="assets/market/background.png" type="image/png">
      <img style="float: right" class="lazyload w-100" alt="Amazon para Cuba"
           data-src="assets/market/background.png">
    </picture>
    <div class="mobile-section-1-1 d-flex flex-column flex-md-row position-relative justify-content-around pt-md-4">
      <div class="mobile-section-1-1-container amazon-texts d-flex flex-column align-items-start p-4 mt-4"
           style="top:5%;left:5%">
        <h2 class="Poppins text-left text-white font-weight-bold"><span class="amazon-text-1 font-weight-normal">¡AHORA PUEDES</span><br>
          <span class="amazon-text-2">ENVIAR<br> PRODUCTOS</span><br><span class="amazon-text-1 font-weight-normal">DE AMAZON A CUBA!</span></h2>
        <a routerLink="/market/envios/amazon-para-cuba"
           class="d-none d-md-flex btn btn-danger text-white px-3 py-2 mt-md-2 mt-lg-4 font-weight-bold OpenSans rounded-pill align-items-center justify-content-center mr-auto w-75"
           style="font-size: 22px;">
          Saber Más</a>
      </div>
      <div class="mobile-section-1-1-img position-relative">
        <picture class="d-flex d-md-none">
          <source data-srcset="assets/market-amazon/panfilo.png" type="image/webp">
          <source data-srcset="assets/market-amazon/panfilo.png" type="image/png">
          <img width="300" height="272" class="lazyload m-auto" alt="Amazon para Cuba"
               data-src="assets/market-amazon/panfilo.png">
        </picture>
        <picture class="d-none d-md-flex">
          <source data-srcset="assets/market-amazon/panfilo.png" type="image/webp">
          <source data-srcset="assets/market-amazon/panfilo.png" type="image/png">
          <img width="400" height="363" class="lazyload m-auto" alt="Amazon para Cuba"
               data-src="assets/market-amazon/panfilo.png">
        </picture>
      </div>
      <div class="d-md-none position-absolute w-100 d-flex justify-content-center" style="bottom: 2%">
        <a routerLink="/market/envios/amazon-para-cuba"
           class=" btn btn-danger text-white px-3 py-2 mt-md-2 mt-lg-4 font-weight-bold OpenSans rounded-pill d-flex align-items-center justify-content-center w-75"
           style="font-size: 22px;">
          Saber Más</a>
      </div>
    </div>

  </div>
</section>

<!-- END DESKTOP SECTION AMAZON -->
